var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1316,
    height: 619,
    viewBox: "0 0 1316 619",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1022.53 0L938.087 102.995L1133.74 516.005H955.593L862.917 619H1182.13H1206.85H1316L1022.53 0Z",
    fill: "#18208A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M953.534 316.195C953.534 154.493 825.847 22.6589 667.268 14.4193H651.822H636.376H479.856L595.186 144.193H651.822C746.557 144.193 822.757 221.439 822.757 316.195C822.757 410.95 745.527 488.196 650.792 488.196H635.346H596.216L477.796 617.97H667.268C826.876 609.73 953.534 477.897 953.534 316.195Z",
    fill: "#18208A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M300.682 14.4193C175.055 14.4193 66.933 91.6655 21.6248 200.84H174.025C205.947 165.822 250.225 144.193 300.682 144.193C336.723 144.193 369.675 155.522 396.448 174.062C442.786 204.96 472.648 257.488 472.648 316.195C472.648 375.932 442.786 428.459 396.448 458.328C368.645 476.867 335.693 488.196 300.682 488.196C244.047 488.196 193.59 460.388 161.668 417.13H15.4463C56.6356 534.544 168.877 617.97 299.653 617.97C466.47 617.97 601.365 482.017 601.365 316.195C602.394 150.373 467.499 14.4193 300.682 14.4193Z",
    fill: "#18208A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23775 238.948C4.11881 253.368 2.05947 267.787 0 282.206V291.476H131.806C134.895 272.937 140.044 254.398 148.282 237.918H8.23775V238.948Z",
    fill: "#FE360B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 326.494V349.153C1.02973 359.453 3.0892 369.752 5.14867 380.052H142.103C135.925 363.572 131.806 346.063 130.776 327.524H0V326.494Z",
    fill: "#FE360B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.c324c5664bfa2fe947b035641c5cce2d.svg";
export { ForwardRef as ReactComponent };